import { on } from 'delegated-events';

// zdarzenie Exponea 'filter': kazda zmiana filtra na listingu (add/remove/remove_all)
// + pelny stan filtrow po akcji i kontekst strony. Zmiany wykrywane diffem parametrow
// URL na pjax:complete - jeden punkt lapie checkboxy, suwak ceny, piguly i grupy kolorow.
const FILTER_PARAMS = ['feature', 'trait', 'producer', 'common', 'category', 'promo', 'campaign', 'available'];
const PENDING_KEY = 'gs-filter-event';

let prevState = null;
let skipNextDiff = false;
const labels = new Map(); // "{typ}_{klucz}" -> { value, group }

function track(payload) {
    if (typeof exponea === 'undefined') return;

    exponea.track('filter', payload);
}

function parseState(search) {
    const params = new URLSearchParams(search);
    const state = {
        values: new Map(),
        priceFrom: params.get('priceFrom'),
        priceTo: params.get('priceTo')
    };

    // piguly zapisuja wartosci po przecinku, formularz jako powtorzone parametry
    FILTER_PARAMS.forEach(type => {
        const values = params.getAll(type).flatMap(v => v.split(',')).filter(Boolean);
        state.values.set(type, new Set(values));
    });

    return state;
}

// etykiety z formularza filtrow (wszystkie wartosci) i pigul (aktywne, takze bez formularza
// na mobile); mapa tylko rosnie - klucze usuniete z DOM musza zostac dla eventow 'remove'
function harvestLabels() {
    document.querySelectorAll('#filter .gs-filtr-container input[type="checkbox"]').forEach(input => {
        const group = input.closest('[data-filter-group]');
        const label = input.nextElementSibling;

        if (!group || !label) return;

        labels.set(input.id, {
            value: label.getAttribute('title') || label.textContent.trim(),
            group: group.getAttribute('data-filter-group')
        });
    });

    document.querySelectorAll('#pills-container .pills-group[data-pills-group-name]').forEach(pillsGroup => {
        const groupName = pillsGroup.getAttribute('data-pills-group-name');

        pillsGroup.querySelectorAll('.single-pill[data-pill-id]').forEach(pill => {
            labels.set(pill.getAttribute('data-pill-id'), {
                value: pill.textContent.trim(),
                group: groupName
            });
        });
    });
}

function resolveLabel(type, value) {
    return labels.get(`${type}_${value}`) || { value: value, group: type };
}

function priceRange(state) {
    return `${state.priceFrom || ''}-${state.priceTo || ''}`;
}

function activeState(state) {
    const active = [];

    state.values.forEach((values, type) => {
        values.forEach(value => {
            const known = resolveLabel(type, value);
            active.push(`${known.group}: ${known.value}`);
        });
    });

    if (state.priceFrom || state.priceTo) {
        active.push(`Cena: ${priceRange(state)}`);
    }

    return { filters_active: active, filters_active_count: active.length };
}

function pageContext() {
    const trigger = document.querySelector('.filter-trigger[data-filter-source]');
    const headline = document.querySelector('.category-headline');
    const context = {
        page_type: 'category', // slownik ciaglosci ze starego sklepu, jak w cart_update
        listing_type: trigger ? trigger.getAttribute('data-filter-source') : null,
        listing_name: headline ? headline.textContent.trim() : null,
        location: window.location.href,
        path: window.location.pathname
    };

    const id = trigger && trigger.getAttribute('data-filter-id');
    if (id) context.listing_id = Number(id);

    const query = trigger && trigger.getAttribute('data-filter-query');
    if (query) context.search_query = query;

    return context;
}

function buildEvent(action, type, value, state) {
    const known = resolveLabel(type, value);

    return Object.assign({
        action: action,
        filter_type: type,
        filter_group: known.group,
        filter_value: known.value,
        filter_value_id: value
    }, activeState(state), pageContext());
}

function buildPriceEvent(state, previous) {
    const cleared = !state.priceFrom && !state.priceTo;
    const event = {
        action: cleared ? 'remove' : 'add',
        filter_type: 'price',
        filter_group: 'Cena',
        filter_value: cleared ? priceRange(previous) : priceRange(state)
    };

    if (state.priceFrom) event.price_from = Number(state.priceFrom);
    if (state.priceTo) event.price_to = Number(state.priceTo);

    return Object.assign(event, activeState(state), pageContext());
}

function diffAndTrack() {
    const current = parseState(window.location.search);
    const events = [];

    FILTER_PARAMS.forEach(type => {
        const before = prevState.values.get(type);
        const after = current.values.get(type);

        after.forEach(value => {
            if (!before.has(value)) events.push(buildEvent('add', type, value, current));
        });
        before.forEach(value => {
            if (!after.has(value)) events.push(buildEvent('remove', type, value, current));
        });
    });

    if (current.priceFrom !== prevState.priceFrom || current.priceTo !== prevState.priceTo) {
        events.push(buildPriceEvent(current, prevState));
    }

    prevState = current;
    events.forEach(track);
}

// "Wyczysc filtry" i szybkie filtry to pelne przeladowania - payload czeka
// w sessionStorage i wychodzi po wczytaniu docelowej strony
function storePending(payload) {
    try {
        sessionStorage.setItem(PENDING_KEY, JSON.stringify(payload));
    } catch (err) { /* tryb prywatny */ }
}

function flushPending() {
    let raw = null;

    try {
        raw = sessionStorage.getItem(PENDING_KEY);
        if (raw) sessionStorage.removeItem(PENDING_KEY);
    } catch (err) {
        return;
    }

    if (!raw) return;

    const payload = JSON.parse(raw);

    // stan po akcji znany dopiero na stronie docelowej (np. szybki filtr)
    if (!('filters_active' in payload)) {
        Object.assign(payload, activeState(parseState(window.location.search)));
    }

    track(payload);
}

export default function () {
    prevState = parseState(window.location.search);
    harvestLabels();
    flushPending();

    document.addEventListener('pjax:complete', function () {
        harvestLabels();

        // back/forward przywraca filtry z historii - to nie jest wybor klienta
        if (skipNextDiff) {
            skipNextDiff = false;
            prevState = parseState(window.location.search);
            return;
        }

        diffAndTrack();
    });

    window.addEventListener('popstate', function () {
        skipNextDiff = true;
    });

    // popstate bez pjaxa (np. hashchange) nie moze polknac diffu nastepnej realnej zmiany
    document.addEventListener('pointerdown', function () {
        skipNextDiff = false;
    });

    on('click', '.remove-all-filters', function () {
        const removed = activeState(parseState(window.location.search));

        storePending(Object.assign({
            action: 'remove_all',
            filters_removed: removed.filters_active,
            filters_active: [],
            filters_active_count: 0
        }, pageContext()));
    });

    on('click', '.quick-filters-wrapper a', function (e) {
        // nowa karta = osobny sessionStorage, payload wyszedlby przy nastepnej nawigacji tutaj
        if (e.ctrlKey || e.metaKey || e.shiftKey || this.target === '_blank') return;

        storePending(Object.assign({
            action: this.classList.contains('selected') ? 'remove' : 'add',
            filter_type: 'quick_filter',
            filter_group: 'Szybkie filtrowanie',
            filter_value: this.textContent.trim()
        }, pageContext()));
    });
}
